import axios from "axios";
import { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  DefaultButton,
  DefaultFullWidthButton,
  FullWidthTextButton,
} from "../../../components/Buttons";
import {
  DefaultInput,
  OtpInput,
  PasswordInput,
  TelephoneInput,
} from "../../../components/Inputs";
import { setUserSession } from '../../../context/auth';
import { User } from "../../../models/User";
import logoImage from '../../../assets/branding/logo.png';
 
function AdminSignInPage() {

  const navigate = useNavigate();

  const [emailInput, setEmailInput] = useState<string>("");
  const [passwordInput, setPasswordInput] = useState<string>("");

  

  const signInFunction = async () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks

    

    if (!emailInput || !passwordInput) {
      return;
    }

    

    await axios.post(process.env.REACT_APP_API_URL + "admin/auth/login", {
      email: emailInput,
      password: passwordInput,
    }, {
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    }).then(response => {
      const { refreshToken, accessToken, user } = response.data;

      localStorage.setItem("refreshToken", refreshToken);

      // set user session

      setUserSession(accessToken, user);

      window.location.href = '/users'
      return;

    }).catch(error => {
      

      try {
        alert(error.response.data.message)
      }
      catch {
        alert("Something went wrong")
      }

      return;
    });
  };

  return (
    <>
      <main>
        <div className="max-w-7xl mx-auto m-0 h-screen w-screen flex items-center justify-center">
          <div className="max-w-md w-full space-y-8 px-3">
            <div>
              <img
                className="mx-auto h-12 w-auto"
                src={logoImage}
                alt="Workflow"
              />
              <h2 className="mt-6 text-center text-3xl tracking-tight font-bold text-gray-900">
                Sign in to your admin account
              </h2>
            </div>
            <div>
              <DefaultInput
                label="Email"
                placeholder="Enter your email"
                onChangeText={(change: string) => setEmailInput(change)}
              />
              <PasswordInput
                label="Password"
                placeholder="Enter your password"
                onChangeText={(change: string) => setPasswordInput(change)}
              />

              <DefaultFullWidthButton
                text={"Continue"}
                onPress={signInFunction}
                disabled={!emailInput || !passwordInput}
              />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default AdminSignInPage;
